import type { User } from "./drawings.types";
import type { ReportTemplate } from "./report-templates.types";

export enum ProjectStatus {
  READY = "READY",
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
}

export interface Project {
  id: number;
  name: string;
  color: string;
  tags: string[];
  status: ProjectStatus;
  createdAt: string;
  updatedAt: string;
  author?: User;
  organization_id: number;
  drawingsCount?: number;
  diagnosticsCount?: number;
  reportTemplate?: ReportTemplate;
}

export type DRPartialProject = Pick<
  Project,
  | "id"
  | "name"
  | "color"
  | "status"
  | "tags"
  | "drawingsCount"
  | "drawingsCount"
  | "diagnosticsCount"
  | "createdAt"
> & { organizationId: number };

export type ProjectPayload = {
  name: string;
  color: string;
  tags: string[];
  status: ProjectStatus;
};

export type GetProjectsFilters = { status?: ProjectStatus[]; search?: string };
